import { useMemo } from "react";
import { useGetMerchantSegments } from "../../../hooks/queries/useMerchantQueries";

export const useMerchantSegmentOptions = () => {
  const { data: labels = [], isLoading, isError } = useGetMerchantSegments();

  const options = useMemo(
    () =>
      Array.isArray(labels)
        ? labels.map((label) => ({ value: label, label }))
        : [],
    [labels],
  );

  const optionsWithAll = useMemo(
    () => [{ value: "", label: "All Merchant Types" }, ...options],
    [options],
  );

  return {
    options,
    optionsWithAll,
    isLoading,
    isError,
    hasOptions: options.length > 0,
  };
};

export default useMerchantSegmentOptions;
